module.exports = require("./fr-SY");